import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import Aos from "aos";
import "aos/dist/aos.css";
import validator from "validator";
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./contact.css";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-contnet: center;
  position: rlative;
  z-index: 1;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: rgba(17, 25, 40, 0.83);
  border: 1px solid rgba(255, 255, 255, 0.125);
  padding: 32px;
  border-radius: 12px;
  box-shadow: rgba(23, 92, 230, 0.1) 0px 4px 24px;
  margin-top: 28px;
  gap: 12px;
`;

const ContactTitle = styled.div`
  font-size: 28px;
  margin-bottom: 6px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`;

const ContactInput = styled.input`
  flex: 1;
  background-color: transparent;
  border: 1px solid
    ${({ theme, isInvalid }) =>
      isInvalid ? "rgba(248, 113, 113, 0.4)" : theme.text_secondary + 50};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid
      ${({ theme, isInvalid }) =>
        isInvalid ? "rgba(248, 113, 113, 0.6)" : theme.primary};
  }
`;

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary + 50};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  resize: none;
  min-height: 200px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`;

const MessageMeta = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: -2px;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ nearLimit, theme }) =>
    nearLimit ? "#fbbf24" : theme.text_secondary};
`;

const ContactButton = styled.button`
  width: 100%;
  text-decoration: none;
  text-align: center;
  background: ${({ disabled }) =>
    disabled ? "hsla(271, 100%, 50%, 0.3)" : "hsla(271, 100%, 50%, 0.9)"};
  padding: 13px 16px;
  margin-top: 2px;
  border-radius: 12px;
  border: none;
  color: ${({ theme }) => theme.text_primary};
  font-size: 18px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: background 0.2s ease;

  &:disabled {
    background: hsla(271, 100%, 50%, 0.3);
    cursor: not-allowed;
  }
`;

const OpenToWork = styled.div`
  margin: 0 0 20px;
  padding: 10px 18px;
  border-radius: 999px;
  background: rgba(30, 144, 255, 0.12);
  border: 1px solid rgba(30, 144, 255, 0.4);
  color: ${({ theme }) => theme.primary};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: center;
`;

const Contact = () => {
  const email_ref = useRef(null);
  const name_ref = useRef(null);
  const subject_ref = useRef(null);
  const message_ref = useRef(null);
  const formref = useRef(null);
  const [submit, setsubmit] = useState(false);
  const [messageCharCount, setMessageCharCount] = useState(0);
  const [emailError, setEmailError] = useState(false);
  const [nameEmpty, setNameEmpty] = useState(true);
  const [subjectEmpty, setSubjectEmpty] = useState(true);
  const [messageEmpty, setMessageEmpty] = useState(true);
  const MAX_CHARS = 1000;
  const WARNING_CHARS = 200;

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    if (emailValue.length > 0) {
      setEmailError(!validator.isEmail(emailValue));
    } else {
      setEmailError(false);
    }
  };

  const handleNameChange = (e) => {
    setNameEmpty(e.target.value.length === 0);
  };

  const handleSubjectChange = (e) => {
    setSubjectEmpty(e.target.value.length === 0);
  };

  const handleMessageChange = (e) => {
    const nextValue = e.target.value;

    if (nextValue.length > MAX_CHARS) {
      e.target.value = nextValue.slice(0, MAX_CHARS);
      setMessageCharCount(MAX_CHARS);
      setMessageEmpty(false);
      return;
    }

    setMessageCharCount(nextValue.length);
    setMessageEmpty(nextValue.length === 0);
  };

  const send_email = async (e) => {
    setsubmit(true);
    e.preventDefault();
    const email = email_ref.current.value;
    const name = name_ref.current.value;
    const subject = subject_ref.current.value;
    const message = message_ref.current.value;

    if (email.length === 0) {
      toast.error("Please enter your email", {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
      return;
    }

    if (!validator.isEmail(email)) {
      toast.warning("Please enter a valid email", {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
      return;
    }

    if (name.length === 0) {
      toast.error("Please enter your name", {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
      return;
    }

    if (subject.length === 0) {
      toast.error("Please enter your subject", {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
      return;
    }

    if (message.length === 0) {
      toast.error("Please enter your message", {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
      return;
    }

    if (message.length > MAX_CHARS) {
      const trimmedMessage = message.slice(0, MAX_CHARS);
      message_ref.current.value = trimmedMessage;
      setMessageCharCount(MAX_CHARS);
      toast.warning(`Message trimmed to ${MAX_CHARS} characters max.`, {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
      return;
    }

    try {
      const response = await fetch("https://formspree.io/f/mgaeakgq", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          from_email: email,
          from_name: name,
          subject: subject,
          message: message,
        }),
      });

      if (response.ok) {
        toast.success("Email sent successfully!", {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          transition: Slide,
        });
        setsubmit(false);
        setMessageCharCount(0);
        formref.current.reset();
        setNameEmpty(true);
        setSubjectEmpty(true);
        setMessageEmpty(true);
        setEmailError(false);
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to send email. Please try again.", {
        position: "top-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setsubmit(false);
    }
  };

  useEffect(() => {
    Aos.init();
  });

  return (
    <div className="ring_body">
      <div className="ring" data-aos="zoom-in" data-aos-once="true">
        <i></i>
        <i></i>
        <i></i>
        <Container id="Education">
          <Wrapper>
            <Title data-aos="zoom-in" data-aos-once="true">
              Contact
            </Title>
            <OpenToWork data-aos="zoom-in" data-aos-once="true">
              Open to Embedded, Low-Level, and Security Opportunities
            </OpenToWork>
            <Desc
              style={{
                marginBottom: "40px",
              }}
              data-aos="zoom-in"
              data-aos-once="true"
            >
              Feel free to reach out for collaboration, internships, and
              full-time opportunities in embedded systems, low-level
              development, and cybersecurity.
            </Desc>

            <ContactForm
              ref={formref}
              data-aos="fade-up"
              data-aos-once="true"
              onSubmit={send_email}
            >
              <ContactTitle>Email Me 🚀</ContactTitle>
              <ContactInput
                placeholder="Your Email"
                name="from_email"
                ref={email_ref}
                onChange={handleEmailChange}
                isInvalid={emailError}
              />
              <ContactInput
                placeholder="What's your Name"
                name="from_name"
                ref={name_ref}
                onChange={handleNameChange}
              />
              <ContactInput
                placeholder="Subject"
                name="subject"
                ref={subject_ref}
                onChange={handleSubjectChange}
              />
              {messageCharCount >= MAX_CHARS - WARNING_CHARS && (
                <MessageMeta
                  nearLimit={messageCharCount >= MAX_CHARS - WARNING_CHARS}
                >
                  {Math.max(MAX_CHARS - messageCharCount, 0)} left
                </MessageMeta>
              )}
              <ContactInputMessage
                placeholder="What would you like to send"
                name="message"
                rows={4}
                ref={message_ref}
                onChange={handleMessageChange}
              />
              <ContactButton
                type="submit"
                disabled={
                  submit ||
                  emailError ||
                  nameEmpty ||
                  subjectEmpty ||
                  messageEmpty
                }
              >
                {submit && (
                  <div class="container">
                    <div className="bar"></div>
                  </div>
                )}
                send
              </ContactButton>
            </ContactForm>
          </Wrapper>
        </Container>
      </div>
    </div>
  );
};

export default Contact;
